export default __webpack_public_path__ + "static/media/GF.b9da3f28.svg";